// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PMUoZLzKd0oN0acQsm0j{flex-direction:column;flex:1;justify-content:center;align-items:center;width:100%;max-width:628px;margin:0 auto;display:flex}.Cy2ybyPwjGoo1v0h4Ocg{margin-bottom:2px}.CmT_WomPd4o4r2qXKJMA{flex-direction:row;justify-content:center;gap:8px;margin-top:-6px;display:flex}.UUaFV9FlnICENBafAU4P{width:156px;text-decoration:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"empty": `PMUoZLzKd0oN0acQsm0j`,
	"title": `Cy2ybyPwjGoo1v0h4Ocg`,
	"actions": `CmT_WomPd4o4r2qXKJMA`,
	"actionButton": `UUaFV9FlnICENBafAU4P`
};
export default ___CSS_LOADER_EXPORT___;
